// extracted by css-extract-rspack-plugin
export default {"root":"wPqbz3","stat":"XkDJg6","label":"uUz2cc","mobile":"YK2443"};